import React from 'react';
import PropTypes from 'prop-types';

export const ExportCSV = ({ data, headers, fileName }) => {
    const handleExport = () => {
      const headerRow = headers.join(';');
      const dataRows = data.map(item => Object.values(item).join(';')).join('\n');
      const csvContent = `${headerRow}\n${dataRows}`;
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
  
    return (
      <button onClick={handleExport}>Esporta file .csv per Excel</button>
    );
};
  
ExportCSV.propTypes = {
    data: PropTypes.array.isRequired,
    headers: PropTypes.array.isRequired,
    fileName: PropTypes.string.isRequired
};
